import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const FileVideo = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <>
        <path
          d='M6.25 7.5a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5'
          fill='currentColor'
        />
        <path
          d='M13 12.94v4.12a.75.75 0 0 0 1.18.614l2.942-2.06a.75.75 0 0 0 0-1.228l-2.942-2.06a.75.75 0 0 0-1.18.615'
          fill='currentColor'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M2 4.75A2.75 2.75 0 0 1 4.75 2h8.5A2.75 2.75 0 0 1 16 4.75V8h3.25A2.75 2.75 0 0 1 22 10.75v8.5A2.75 2.75 0 0 1 19.25 22h-8.5A2.75 2.75 0 0 1 8 19.25V16H4.75A2.75 2.75 0 0 1 2 13.25zm12.5 0V8h-3.75a2.75 2.75 0 0 0-2.733 2.444l-.494-.329a2.75 2.75 0 0 0-3.05 0l-.973.649V4.75c0-.69.56-1.25 1.25-1.25h8.5c.69 0 1.25.56 1.25 1.25m-7.809 6.613L8 12.236V14.5H4.75c-.69 0-1.25-.56-1.25-1.25v-.684l1.805-1.203c.42-.28.967-.28 1.386 0M9.5 19.25v-8.5c0-.69.56-1.25 1.25-1.25h8.5c.69 0 1.25.56 1.25 1.25v8.5c0 .69-.56 1.25-1.25 1.25h-8.5c-.69 0-1.25-.56-1.25-1.25'
          fill='currentColor'
        />
      </>
    ) : (
      <>
        <path
          d='M6.25 7.5a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5'
          fill='currentColor'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M4.75 2A2.75 2.75 0 0 0 2 4.75v8.5A2.75 2.75 0 0 0 4.75 16H8v3.25A2.75 2.75 0 0 0 10.75 22h8.5A2.75 2.75 0 0 0 22 19.25v-8.5A2.75 2.75 0 0 0 19.25 8H16V4.75A2.75 2.75 0 0 0 13.25 2zm9.75 6V4.75c0-.69-.56-1.25-1.25-1.25h-8.5c-.69 0-1.25.56-1.25 1.25v6.014l.973-.649a2.75 2.75 0 0 1 3.05 0l.494.33A2.75 2.75 0 0 1 10.75 8zM8 12.236l-1.309-.873a1.25 1.25 0 0 0-1.386 0L3.5 12.566v.684c0 .69.56 1.25 1.25 1.25H8zm5 4.823V12.94a.75.75 0 0 1 1.18-.614l2.942 2.06a.75.75 0 0 1 0 1.228l-2.942 2.06A.75.75 0 0 1 13 17.06'
          fill='currentColor'
        />
      </>
    )}
  </IconBase>
);
